import { useState, useEffect, useCallback, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import SideModal from "../../Components/SideModal";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import AddTransferDetail from "../../Components/Payout/AddTransferDetail";
import Table from "../../Components/Payout/TransferTable";
import ViewTransferDetails from "../../Components/Payout/ViewTransferDetails";
import { useLocation } from "react-router-dom";
import moment from "moment";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import SummaryCards from "../../Components/Payout/TransferSummary";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { useNavigate } from "react-router-dom";
import useVerifyBankAccount from "../../utilities/useVerifyBankAccount";

const Transfers = () => {
    const searchOptions = [
        { label: "Account", value: 1 },
        // { label: "Mobile", value: 3 },
        { label: "UTR", value: 2 },
        { label: "Done By", value: 3 },
    ];
    const initialLoadRef = useRef(false);

    const navigate = useNavigate();
    const [summaryData, setSummaryData] = useState();
    const [selectedId, setSelectedId] = useState(null);
    const user = useSelector((state) => state.UserReducer.user);
    const location = useLocation();
    const beneficaryDetails = location.state?.beneficaryDetails;
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [addTransferDetails, setAddTransferDetails] = useState(false);
    const [beneficiariesData, setBeneficiaries] = useState([]);
    const [categories, setCategories] = useState([]);
    const [viewDetails, setViewDetails] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    //const [verifyErrorMsg, setVerifyErrorMsg] = useState("")

    //const [verifiedAccountName, setVerifiedAccountName] = useState("");
    //const [isAccountVerified, setIsAccountVerified] = useState(false);
    const [startDate, setStartDate] = useState(
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        moment(new Date()).format("YYYY-MM-DD")
    );

    const buildQueryParams = useCallback(() => {
        const params = new URLSearchParams();
        params.append('startDate', startDate);
        params.append('endDate', endDate);
        if (searchQuery) {
            params.append('s', searchQuery);
        }
        if (filterType) params.append('t', filterType);
        return params.toString();
    }, [startDate, endDate, searchQuery, filterType]);

    const fetchFunction = async ({ queryKey }) => {
        const [
            ,
            startDate,
            endDate,
            searchQuery,
            filterType,
            beneficiaryId,
        ] = queryKey;

        const params = new URLSearchParams();

        params.append("startDate", startDate);
        params.append("endDate", endDate);

        if (searchQuery) {
            params.append("s", searchQuery);
        }

        if (filterType) {
            params.append("t", filterType);
        }

        const url = beneficaryDetails?.cfBeneficiaryId
            ? `${Config.apiUrl}/cashfree/payout/list/transfers?beneficiaryId=${beneficaryDetails.id}`
            : `${Config.apiUrl}/cashfree/payout/list/transfers?${params.toString()}`;

        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${user.token}`,
            },
        });

        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) {
            setApiData([]);
        } else {
            const data = res?.data || [];
            const beneficiaries = res?.beneficiaries
            setApiData(data);
            setFilteredData(data);
            setSummaryData(res?.summary);
            setCategories(res?.categories);
            setBeneficiaries(beneficiaries)
        }
    };

    const getError = () => {
        setApiData([]);
    };

    const {
        isLoading,
        //mutate: getListMutate,
        error,
        data,
        isFetching: isRefetching,
        refetch: getListMutate,
    } = useQuery(
        [
            "transfers",
            startDate,
            endDate,
            searchQuery,
            filterType,
            beneficaryDetails?.id,
        ],
        fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        getListMutate();
    }, []);

    // useEffect(() => {
    //     if (initialLoadRef.current) {
    //         return;
    //     }

    //     initialLoadRef.current = true;

    //     getListMutate();
    // }, []);

    //------- Initiate Transfer -------
    const AddTransferAccountFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/cashfree/payout/transfer`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const transferSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg);
            setAddTransferDetails(false);
            getListMutate();
        } else {
            toast.error(data?.data?.msg);
        }
    };

    const transferError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addTransferAccountLoading, mutate: addTransferAccountMutate } =
        useMutation(AddTransferAccountFunction, {
            onSuccess: transferSuccess,
            onError: transferError,
        });

    const handleAddBankClose = () => {
        setAddTransferDetails(false);
        //setVerifyErrorMsg("");
        clearVerification();
        //setVerifiedAccountName("");
        //setIsAccountVerified(false);
    };

    // const submitHandler = (values) => {
    //     const newValues = {
    //         startDate: moment(values.startDate).format("YYYY-MM-DD"),
    //         endDate: moment(values.endDate).format("YYYY-MM-DD"),
    //     };
    //     setFilterType("");
    //     setSearchQuery("");
    //     setStartDate(newValues.startDate);
    //     setEndDate(newValues.endDate);
    //     const handler = setTimeout(() => {
    //         getListMutate();
    //     }, 100);
    //     return () => {
    //         clearTimeout(handler);
    //     };
    // };

    // const handleFilterChange = (values) => {
    //     setFilterType(values.filterType);
    //     setSearchQuery(values.searchQuery);
    //     const handler = setTimeout(() => {
    //         getListMutate();
    //     }, 100);
    //     return () => {
    //         clearTimeout(handler);
    //     };
    // };

    // const handleClearFilters = () => {
    //     setFilterType("");
    //     setSearchQuery("");
    //     const handler = setTimeout(() => {
    //         getListMutate();
    //     }, 100);
    //     return () => {
    //         clearTimeout(handler);
    //     };
    // };

    const submitHandler = (values) => {
        setFilterType("");
        setSearchQuery("");
        setStartDate(moment(values.startDate).format("YYYY-MM-DD"));
        setEndDate(moment(values.endDate).format("YYYY-MM-DD"));
    };

    const handleFilterChange = (values) => {
        setFilterType(values.filterType);
        setSearchQuery(values.searchQuery);
    };

    const handleClearFilters = () => {
        setFilterType("");
        setSearchQuery("");
    };

    const onSummaryBoxClick = (filter) => {
        sessionStorage.removeItem("transfer_active_page");
        if (filter === "Navigate") {
            navigate("/payout/recharge")
            return;
        }
        if (filter === "All" || filter === "ALL") {
            setFilteredData(apiData);
            return;
        }

        const filtered = apiData.filter((item) => {
            if (filter === "SUCCESS") {
                return item.status === Config.TRANSFER_STATUS.SUCCESS;
            }
            if (filter === "PENDING") {
                return item.status === Config.TRANSFER_STATUS.INITIATED;
            }
            if (filter === "FAILED") {
                return item.status === Config.TRANSFER_STATUS.FAILED;
            }
            if (filter === "REVERSED") {
                return item.status === Config.TRANSFER_STATUS.REVERSED;
            }
            return true;
        });

        setFilteredData(filtered);
    };

    // const verifyBankFunction = async (data) => {
    //     const response = await axios.get(
    //         `${Config.apiUrl}/cashfree/payout/verify/account?accountNumber=${data?.accountNumber}&ifsc=${data?.ifsc}`,
    //         {
    //             headers: {
    //                 authorization: "Bearer " + user.token,
    //                 "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    //             },
    //         }
    //     );
    //     return response.data;
    // };

    // const getVerifyBankSuccess = (res) => {
    //     if (res.isSuccess) {
    //         setVerifiedAccountName(res?.data?.accountHolderName);
    //         setIsAccountVerified(res?.data?.isVerified);
    //         setVerifyErrorMsg("")
    //     }
    // };
    // const getVerifyBanlError = (res) => {

    //     if (res?.response?.data?.msg) {
    //         setVerifyErrorMsg(res.response.data.msg);
    //     }
    //     else {
    //         setVerifyErrorMsg("Account verification failed. Please check the account number and IFSC code.");
    //     }

    //     setVerifiedAccountName("");
    //     setIsAccountVerified(false);
    // };

    // const { isLoading: verifyAccountLoading, mutate: verifyBankAccountMutate, error: isVerifyBankError } = useMutation(verifyBankFunction, {
    //     onSuccess: getVerifyBankSuccess,
    //     onError: getVerifyBanlError,
    // });

    const {
        verifyBankAccount,
        verifyAccountLoading,
        isAccountVerified,
        verifiedAccountName,
        verifyErrorMsg,
        clearVerification,
    } = useVerifyBankAccount(user.token);

    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    {"Transfers"}
                    <Underline />
                </BoxTitle>
                <Filters setAddBaneficiaryDetails={setAddTransferDetails} />
            </BoxHead>

            {(isLoading || isRefetching) && (
                <SummarySkeletonLoading count={7} />
            )}
            {!isLoading && !isRefetching && summaryData && (
                <SummaryCards summaryData={summaryData} onClick={onSummaryBoxClick} setSelectedId={setSelectedId} selectedId={selectedId} />
            )}

            <FilterTableWrapper>
                <FilterWrapperWithSearch>
                    <div className="flex flex-col md:flex-row md:items-center gap-4">
                        <SearchFilterBox
                            options={searchOptions}
                            handleFilterChange={handleFilterChange}
                            handleClearFilters={handleClearFilters}
                        />
                        <DateRange
                            submitHandler={submitHandler}
                            defaultLabel={
                                moment(startDate).format("DD MMM yyyy") +
                                " - " +
                                moment(endDate).format("DD MMM yyyy")
                            }
                        />
                    </div>

                </FilterWrapperWithSearch>

                {!error && !isLoading && data && (
                    <TableWrapper>
                        <Table
                            apiData={error ? [] : filteredData}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            setViewDetails={setViewDetails}
                        />
                        {(!error && apiData?.length === 0 && !isLoading && !isRefetching) && (
                            <NotFoundModel />
                        )}
                        {(isLoading || isRefetching) && <Loading />}

                    </TableWrapper>
                )}
            </FilterTableWrapper>
            {(isLoading || isRefetching) && <Loading />}
            {error && !isLoading && <NotFoundModel />}

            <SideModal
                isOpen={addTransferDetails}
                onClose={() => setAddTransferDetails(false)}
            >
                <AddTransferDetail
                    handleClose={handleAddBankClose}
                    addTransferAccountLoading={addTransferAccountLoading}
                    addTransferAccountMutate={addTransferAccountMutate}
                    setAddTransferDetails={setAddTransferDetails}
                    beneficiariesData={beneficiariesData}
                    availableAmount={summaryData?.payoutData?.walletBalance || summaryData?.balance}
                    maxTransLimit={summaryData?.payoutData?.maxTransLimit || 0}
                    expCategories={categories}
                    verifyBankAccount={verifyBankAccount}
                    verifyAccountLoading={verifyAccountLoading}
                    verifiedAccountName={verifiedAccountName}
                    //setVerifiedAccountName={setVerifiedAccountName}
                    isAccountVerified={isAccountVerified}
                    verifyErrorMsg={verifyErrorMsg}
                    //setVerifyErrorMsg={setVerifyErrorMsg}
                    clearVerification={clearVerification}
                />
            </SideModal>
            <SideModal
                isOpen={viewDetails}
                onClose={() => setViewDetails(false)}
            >
                <ViewTransferDetails
                    setViewDetails={setViewDetails}
                    selectedData={selectedData}
                />
            </SideModal>
        </BoxContainer>
    );
};
const Filters = ({ setAddBaneficiaryDetails }) => {
    return (
        <Formik>
            <Form>
                <FilterContainer>
                    <AddBtn
                        type="button"
                        onClick={() => {
                            setAddBaneficiaryDetails(true);
                        }}
                    >
                        Make Payout
                    </AddBtn>
                </FilterContainer>
            </Form>
        </Formik>
    );
};
const TableWrapper = tw.div`mt-4 bg-white rounded-md `;
const AddBtn = tw.button`border whitespace-nowrap border-gray-200 flex items-center justify-center text-white h-full rounded-md px-4 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm transition-colors duration-200`;
const FilterContainer = tw.div`grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;

export default Transfers;